const latestSystemNotificationSelector = state => state?.latestSystemNotification?.system_notification;

export default latestSystemNotificationSelector;
